



















import * as Sentry from '@sentry/browser';
import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

import { PolicyUi } from '@/common/Policy';
import Auth from '@/services/Auth';
import PolicyService from '@/services/Policy';
import Brand from '@/services/Brand';
import Card from '@/components/Global/Card.vue';

import Loading from '@/components/Global/Loading.vue';

@Component({
	name: 'AgentMessage',
	components: {
        Loading,
        Card
	},
})
export default class AgentMessage extends Vue {
	@Getter('activePolicies', { namespace: 'Policy' }) private policies: PolicyUi[];

    private readonly Auth = Auth;
    private readonly BrandInfo = Brand.getBrandInformation();

    private loading: boolean = false;

    private async created() {
        await this.getPolicies();
    }

    private async getPolicies() {
        this.loading = true;
        try {
			// Even though policies have likely already been fetched, thanks to
			// '@routing/GetPolicyInfo.ts', this forces a refresh for the most up-to-date
			// information.
			await PolicyService.setPolicyData();
		} catch (error) {
			console.error(error);
			Sentry.captureException(error);
		} finally {
			this.loading = false;
		}
    }
}
